/*=============================================== PropsItem styles ===============================================*/

import styled from "styled-components/macro"
import { Hr } from "tsx-library-julseb"

export const StyledPropsItems = styled.div<{}>``

export const StyledHr = styled(Hr)`
    width: 80%;
    align-self: center !important;
`
